var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "100px",
          "search-btn-span": _vm.colSpan,
          "default-sort": _vm.defaultSort,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { contentMethod: false, enterable: true },
        },
        on: {
          afterFetchOriginalData: _vm.getTableData,
          "sort-change": _vm.sortChange,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "cusId",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.No"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("InternalOrder.No"),
                            comma: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.SKU"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("InternalOrder.SKU") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrder2.means"),
                          prop: "shippingMethod",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("BusinessPurchaseOrder2.means"),
                            "option-list": _vm.CSG_ORDER_SHIPPING_METHODS_LIST,
                          },
                          model: {
                            value: _vm.queryParams.shippingMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "shippingMethod", $$v)
                            },
                            expression: "queryParams.shippingMethod",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.consignmentNum"),
                          prop: "logisticsNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t("billingPage.consignmentNum"),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsNo", $$v)
                            },
                            expression: "queryParams.logisticsNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.CourierName"),
                          prop: "logisticsCompany",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            multiple: "",
                            placeholder: _vm.$t("InternalOrder.CourierName"),
                            "option-list": _vm.CourierNameList,
                          },
                          model: {
                            value: _vm.queryParams.logisticsCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsCompany", $$v)
                            },
                            expression: "queryParams.logisticsCompany",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("InternalOrder.order") } },
                      [
                        _c("BjDateRangePicker", {
                          attrs: { placeholder: _vm.$t("InternalOrder.order") },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.queryParamsTradeStatus !== "2"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.$t("InternalOrder.orderOFF") },
                          },
                          [
                            _c("BjDateRangePicker", {
                              attrs: {
                                placeholder: _vm.$t("InternalOrder.orderOFF"),
                              },
                              model: {
                                value: _vm.queryParamsTime_receive,
                                callback: function ($$v) {
                                  _vm.queryParamsTime_receive = $$v
                                },
                                expression: "queryParamsTime_receive",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.queryParamsTradeStatus === "0"
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("orderNewPatch.Status"),
                              prop: "totalOrderStatus",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                placeholder: _vm.$t("orderNewPatch.Status"),
                                multiple: "",
                                "option-list":
                                  _vm.ORDER_INTERNAL_YES_STATUS_LIST,
                              },
                              on: { change: _vm.selectSome },
                              model: {
                                value: _vm.statusList,
                                callback: function ($$v) {
                                  _vm.statusList = $$v
                                },
                                expression: "statusList",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeSearchBtn",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: 24 - _vm.colSpan } },
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: {
                          value: _vm.queryParamsTradeStatus,
                          type: "card",
                        },
                        on: { "tab-click": _vm.handleTabClick },
                      },
                      _vm._l(
                        _vm.CSG_ORDER_INTERNAL_ORDER_STATUS_CSG_LIST,
                        function (item, index) {
                          return _c("el-tab-pane", {
                            key: index,
                            attrs: {
                              label: _vm.$t(item.label),
                              name: item.value,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjFrontendExport", {
                      attrs: {
                        type: "primary",
                        "label-list": _vm.exportLabelList,
                        rows: _vm.selectedRows,
                        "file-name": "Closed Orders.csv",
                      },
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onFullExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportFullText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop === "orderTime"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "orderTime",
                            title: _vm.$t("orderNewPatch.orderDate"),
                            width: "140px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop]
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "creationDate"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "creationDate",
                            title: _vm.$t("orderNewPatch.creationDate"),
                            width: "150px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop],
                                            {
                                              isSession: true,
                                              dateFormat: "DD/MM/YYYY HH:mm",
                                            }
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.webReference)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "logisticsNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openTrackingDetails(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "totalOrderStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] === 5
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_YES_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "orderHandleStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.ORDER_WMS_STATUS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "shippingMethod"
                                      ? [
                                          _c("el-tag", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "receiveTime"
                                      ? [
                                          scope.row.totalOrderStatus === 5
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("timeFilters")(
                                                      scope.row.receiveTime,
                                                      {
                                                        isSession: true,
                                                        dateFormat:
                                                          "DD/MM/YYYY HH:mm",
                                                      }
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          scope.row.totalOrderStatus === 6
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("timeFilters")(
                                                      scope.row.payTime,
                                                      {
                                                        isSession: true,
                                                        dateFormat:
                                                          "DD/MM/YYYY HH:mm",
                                                      }
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      : col.prop === "supplierName"
                                      ? [
                                          scope.row[col.prop] == "Urgent"
                                            ? _c(
                                                "el-tag",
                                                { attrs: { type: "success" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row[col.prop])
                                                  ),
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row[col.prop])
                                                ),
                                              ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toViewOrder(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    _c(
                                      "el-dropdown",
                                      {
                                        directives: [
                                          {
                                            name: "hasDropdownChildren",
                                            rawName: "v-hasDropdownChildren",
                                          },
                                        ],
                                        on: {
                                          command: function ($event) {
                                            return _vm.handleActionCommand(
                                              $event,
                                              props.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "el-dropdown-link" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "AccountManagement.common.operate"
                                                )
                                              )
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "el-icon-arrow-down el-icon--right",
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown",
                                          },
                                          [
                                            _vm.$store.getters.cusId &&
                                            props.row.totalOrderStatus == "6"
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: { command: "copy" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("copyText"))
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            !_vm.$store.getters.cusId &&
                                            props.row.totalOrderStatus == "5"
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      disabled:
                                                        _vm.disShippingMethod(
                                                          props.row
                                                        ),
                                                      command:
                                                        "customerDelivery",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "InternalSalesOrderDetails.customerDelivery"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            props.row.totalOrderStatus == "5" &&
                                            ["AUSP", "AUSX"].includes(
                                              props.row.logisticsBusinessName
                                            )
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: "returnLabel",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "InternalSalesOrderDetails.ReturnLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.showFeeButton
                                              ? _c(
                                                  "el-dropdown-item",
                                                  { attrs: { command: "fee" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("feeTab.fee")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("delveryDialog", {
        ref: "delveryDialogRef",
        on: { reFresh: _vm.reFresh },
      }),
      _c("DeliverDialog", { ref: "DeliverDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }